export default __webpack_public_path__ + "static/media/qr-fastweb-icon.234e025b.svg";